<script setup lang="ts">
import useSocketIO from "~/hooks/use-socket-io";
import useDeviceSocket from "~/hooks/use-socket-io/use-device-socket";
import useUserStore from "~/stores/user";
import DeviceAPI from "~/services/device";
import { initFacebookSdk } from "~/services/auth/facebook";
import { initGoogleSdk } from "~/services/auth/google";
import { initAppleSdk } from "~/services/auth/apple";

const route = useRoute();
const router = useRouter();
const color = useColorMode();
const appConfig = useRuntimeConfig().public;
const userStore = useUserStore();
const { locale: currentLocale } = useI18n();

function onDeviceLimitError(error?: Error) {
  // eslint-disable-next-line no-console
  console.log(error);

  if (route.name === "auth-login-limit")
    return;

  if ((error as Error & { code?: string })?.code === "refresh_token_failed")
    return;

  userStore.logout();
  router.push({ path: "/auth/login/", query: { deviceNoLongerAllowedError: "true" } });
}

onMounted(() => {
  if (appConfig.APP_CUSTOMER.app_config.enable_auth_via_facebook && appConfig.APP_CUSTOMER.app_config.app_id_facebook)
    initFacebookSdk();

  if (appConfig.APP_CUSTOMER.app_config.enable_auth_via_google && appConfig.APP_CUSTOMER.app_config.app_client_id_for_google)
    initGoogleSdk();

  if (appConfig.APP_CUSTOMER.app_config.enable_auth_via_apple && appConfig.APP_CUSTOMER.app_config.app_client_id_for_apple)
    initAppleSdk();

  if (!appConfig.APP_CUSTOMER.enable_white_theme && color?.preference)
    color.preference = "dark";

  const socket = useSocketIO();

  if (socket)
    useDeviceSocket(socket, { onDeviceRemoved: onDeviceLimitError });

  if (userStore.isAuthenticated)
    DeviceAPI.checkCurrent().catch(error => onDeviceLimitError(error));
});

useHead({
  meta: [
    { name: "theme-color", content: computed(() => (color.value === "dark" ? "#0f1624" : "#f4f7fc")) },
  ],
  // @ts-expect-error FIXME:
  htmlAttrs: [{
    lang: computed(() => currentLocale.value || "en"),
    dir: computed(() => currentLocale.value === "he" ? "rtl" : "ltr"),
  }],
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
